/*
  GS Instant Variant – Fix für das Varianten-Race auf Produktseiten.

  Problem (siehe docs/2026-07-13-variant-race-briefing.md):
  Nach einem Options-Klick setzt Dawn die Varianten-ID im product-form erst,
  wenn der Sektions-Fetch zurück ist (~1s bei schlechter Verbindung). Wer im
  Fenster dazwischen "In den Warenkorb" tippt, legt die ALTE Variante ein.

  Fix: Beim Options-Klick die Varianten-ID sofort clientseitig aus der im
  Picker eingebetteten Varianten-Map ([data-gs-variant-map]) auflösen und in
  die Produkt-Formulare schreiben. NUR bei eindeutigem Match – sonst passiert
  nichts (Fallback = bisheriges Dawn-Verhalten, der Fetch korrigiert später).

  Bewusst NICHT angefasst: Button-Disable-Logik (Verfügbarkeit), Preis/Medien –
  das erledigt weiterhin Dawns Sektions-Fetch.
*/
(function () {
  'use strict';

  function selectedOptionValues(variantSelects) {
    // Options-Container in DOM-Reihenfolge = Options-Positionsreihenfolge:
    // je Option genau ein fieldset (Radios/Karten/Pills/Swatches)
    // oder ein Dropdown-Wrapper (select).
    var containers = variantSelects.querySelectorAll(
      'fieldset.product-form__input, .product-form__input--dropdown'
    );
    var values = [];
    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      var value = null;
      if (el.matches('fieldset')) {
        var checked = el.querySelector('input[type="radio"]:checked');
        value = checked ? checked.value : null;
      } else {
        var select = el.querySelector('select');
        value = select ? select.value : null;
      }
      if (value === null || value === '') return null; // unvollständig → nicht raten
      values.push(value);
    }
    return values.length ? values : null;
  }

  function findUniqueVariant(variants, values) {
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.options || v.options.length !== values.length) continue;
      var equal = true;
      for (var j = 0; j < values.length; j++) {
        if (v.options[j] !== values[j]) { equal = false; break; }
      }
      if (equal) {
        if (match) return null; // mehr als ein Treffer → nicht eindeutig
        match = v;
      }
    }
    return match;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches('input[type="radio"], select')) return;

    var variantSelects = target.closest('variant-selects');
    if (!variantSelects) return;

    var productInfo = variantSelects.closest('product-info');
    if (!productInfo) return;

    // Combined Listings (Klick wechselt das Produkt): Map gehört zum alten
    // Produkt → nichts tun, Dawns Fetch übernimmt.
    if (target.dataset.productUrl && target.dataset.productUrl !== productInfo.dataset.url) return;

    var mapEl = variantSelects.querySelector('[data-gs-variant-map]');
    if (!mapEl) return;

    var variants;
    try {
      variants = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var values = selectedOptionValues(variantSelects);
    if (!values) return;

    var variant = findUniqueVariant(variants, values);
    if (!variant || !variant.id) return;

    // Varianten-ID sofort in die Produkt-Formulare schreiben.
    // (Auch bei ausverkaufter Variante: falsche ID wäre schlimmer – der
    // Submit-Button-Zustand wird weiterhin von Dawns Fetch gesteuert.)
    var section = productInfo.dataset.section;
    var inputs = productInfo.querySelectorAll(
      '#product-form-' + section + ' input[name="id"], ' +
      '#product-form-installment-' + section + ' input[name="id"]'
    );
    inputs.forEach(function (input) {
      input.value = variant.id;
    });
  });
})();
